/**
 * Configurações específicas para o cliente "Banese"
 */

const settings: ClientSettings = {
  name: "Banese",
  in100authority: "Banese",
  downloadTermText: "Banese",
  theme: {
    token: {
      colorPrimary: "#256136",
    },
  },
  assets: {
    logo: "/logo-banese.png",
    favicon: "/favicon-banese.png",
    card: "/card-banese.png",
    refinCard: "/card-banese.png",
    consignedCard: "/card-banese.png",
    bankLogo: "",
    bank_name: "bmp",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#256136",
      },
    },
    assets: {
      logo: "/logo-banese.png",
      favicon: "/favicon-banese.png",
    },
  },
};

export default settings;
